<template>
    <span>{{ value }} {{ unitString }}</span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n';

export default defineComponent({
    props: {
        value: {
            type: Number,
            required: true,
        },

        unit: {
            type: String,
            required: true,
        }
    },

    setup(props)
    {
        const { t } = useI18n();

        const unitString = computed(() => {
            if (props.unit.length === 0) {
                return "";
            }

            return t(`unit.${props.unit}`);
        });

        return { unitString };
    },
})
</script>
